import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        forms: '<',
        context: '=',
        canManageCourse: '<',
        trainingForm: '=',
        key: '<',
        trainingTypes: '<',
        hasPlanningGroups: '<',
        ckconfig: '<',
        isDisabled: '<',
        hasPublishedOccurrence: '<',
        feedbackForms: '=',
        formCopy: '='
    },
    template: `
        <div class="block07">
            <div class="row row-wide mt20">
                <label class="label w100p">{{ 'training.Randomized form assignment for testees' | translate }}</label>
                <div class="items w100p">
                    <ul class="checkboxes">
                        <li>
                            <label><input
                                ng-disabled="vm.isDisabled"
                                type="checkbox"
                                ng-change="vm.removeForms()"
                                ng-model="vm.trainingForm.isFormRandomized">{{ 'general.Yes' | translate }}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <form-row-wide ng-if="!vm.trainingForm.isFormRandomized" error="vm.form.errors.courseTrainings[vm.key].formId">
                <span class="row row-wide" ng-class="{ 'has-error': vm.form.errors.courseTrainings[vm.key].formId }">
                    <label class="label w100p mt10">{{ 'training.Form' | translate }} *</label>
                    <div class="items w100p">
                        <select ng-disabled="vm.isDisabled" class="form-control"
                            ng-model="vm.trainingForm.formId"
                            ng-options="form.id as form.activeI18n.name for form in vm.forms" required>
                        </select>
                        <form-row-wide-error></form-row-error>
                        <p class="desc warn" ng-if="!vm.hasAccessToTestForm(vm.trainingForm.formId)">
                            {{ 'courses.Saved value is not displayed. You do not have access to the attached form' | translate }}
                        </p>
                        <p class="desc warn" ng-if="vm.showNeedsAssessment()">{{ 'training.Test needs manual assessment' | translate }}</p>
                        <p class="desc warn" ng-if="vm.showQuestionsAssignedRandomly()">{{ 'training.Questions to test are assigned randomly' | translate }}</p>
                    </div>
                </span>
                <div class="alert alert-warn has-icon" ng-if="vm.form.warnings.courseTrainings[vm.key].formId">
                    <img class="alert-icon" alt="Needs attention" src="assets/css/icon_warn.svg">
                    {{ vm.form.warnings.courseTrainings[vm.key].formId }}
                </div>
            </form-row-wide>
            <form-row-wide ng-if="vm.trainingForm.isFormRandomized" error="vm.form.errors.courseTrainings[vm.key].formIds">
                <span class="row row-wide" ng-class="{ 'has-error': vm.form.errors.courseTrainings[vm.key].formIds }">
                    <label class="label w100p mt10">{{ 'training.Associated forms' | translate }} *</label>
                    <div class="items w100p">
                        <tags-input
                            key-property="id"
                            ng-disabled="!vm.canManageCourse"
                            display-property="name"
                            add-from-autocomplete-only="true"
                            replace-spaces-with-dashes="false"
                            ng-model="vm.trainingForm.forms"
                            on-tag-removing="vm.removeTag($tag, vm.key)"
                            placeholder="{{ 'training.Add form' | translate }}">
                            <auto-complete min-length="1" source="vm.filterForms($query)"></auto-complete>
                        </tags-input>
                        <form-row-wide-error></form-row-error>
                    </div>
                </span>
            </form-row-wide>
        </div>
    `
})

export default class {
    constructor (lodash, toastr, TokenService, CourseVersionService, CourseVersionTrainingFormService,
                 CourseVersionTrainingFormLearndashService, CourseVersionTrainingFormFileService,
                 COURSE_TRAINING_TYPE_ENUM, COURSE_TRAINING_PASSING_TYPE_ENUM, $translate) {
        this.lodash = lodash;
        this.toastr = toastr;
        this.TokenService = TokenService;
        this.CourseVersionService = CourseVersionService;
        this.CourseVersionTrainingFormService = CourseVersionTrainingFormService;
        this.CourseVersionTrainingFormLearndashService = CourseVersionTrainingFormLearndashService;
        this.CourseVersionTrainingFormFileService = CourseVersionTrainingFormFileService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.$translate = $translate;
    }

    $onInit () {
        this.tooltipTexts = {
            passingType: this.$translate.instant('courses.Training passing type tooltip'),
            description: this.$translate.instant('courses.Training description tooltip')
        };
    }

    removeTag (tag, trainingKey) {
        // if training has no previously related forms then it's all good to remove "on the fly" added forms
        if (!this.lodash.has(this.formCopy.model.courseTrainings[trainingKey], 'forms')) {
            return true;
        }
        // use here formCopy to detect formIds that were connected before to differ "on the fly" added forms
        const formIds = this.formCopy.model.courseTrainings[trainingKey].forms.map(form => form.id);
        if (this.hasPublishedOccurrence && this.lodash.includes(formIds, tag.id)) {
            const error = this.$translate.instant(
                'training.Can not remove form {form} because training is connected to published occurrence',
                { form: tag.name }
            );
            this.toastr.error(error);
            return false;
        }
        return true;
    }

    filterForms (query) {
        const data = this.forms.filter((form) => this.lodash.includes(form.activeI18n.name.toUpperCase(), query.toUpperCase()));
        data.forEach((form) => {
            form.name = form.activeI18n.name;
        });
        return data;
    }

    hasAccessToTestForm (formId) {
        if (!formId) {
            return true;
        }

        return !!this.lodash.find(this.forms, (form) => parseInt(form.id, 10) === parseInt(formId, 10));
    }

    hasAccessToFeedbackForm (formId) {
        if (!formId) {
            return true;
        }

        return !!this.lodash.find(this.feedbackForms, (form) => parseInt(form.id, 10) === parseInt(formId, 10));
    }

    hasAccessToAssociatedForms (selectedForms) {
        if (!selectedForms || selectedForms.length === 0) {
            return true;
        }

        const formIds = this.forms.map((form) => form.id);
        const selectedFormIds = selectedForms.map((form) => form.id);

        return this.lodash.difference(selectedFormIds, formIds).length === 0;
    }

    showNeedsAssessment () {
        if (this.trainingForm.formId) {
            const formId = this.trainingForm.formId;
            if (this.hasAccessToTestForm(formId)) {
                const chosenForm = this.lodash.find(this.forms, (form) => parseInt(form.id, 10) === parseInt(formId, 10));
                return chosenForm.hasAssessmentQuestions;
            }
        }
        else if (this.trainingForm.forms) {
            if (this.hasAccessToAssociatedForms(this.trainingForm.forms)) {
                return this.lodash.filter(this.trainingForm.forms, (form) => form.hasAssessmentQuestions).length;
            }
        }
        return false;
    }

    showQuestionsAssignedRandomly () {
        if (this.trainingForm.formId) {
            const formId = this.trainingForm.formId;
            if (this.hasAccessToTestForm(formId)) {
                const chosenForm = this.lodash.find(this.forms, (form) => parseInt(form.id, 10) === parseInt(formId, 10));
                return chosenForm.isRandomizedQuestionsAssigned;
            }
        }
        else if (this.trainingForm.forms) {
            if (this.hasAccessToAssociatedForms(this.trainingForm.forms)) {
                return this.lodash.filter(this.trainingForm.forms, (form) => form.isRandomizedQuestionsAssigned).length;
            }
        }
        return false;
    }

    removeForms () {
        this.trainingForm.formId = null;
        this.trainingForm.forms = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/test/index.js